import PropTypes from 'prop-types'

import useIsMobile from '../../../../hooks/useIsMobile'
import BasicInfoSection from './BasicInfoSection'
import TrackingSectionDesktop from './TrackingSectionDesktop'
import OriginDestinationSection from './OriginDestinationSection'
import useShippingActions from '../../../../App/ShippingsTracking/TrackingTable/useShippingActions'
import { Button } from '@mui/material'
import styles from '../styles'

const Content = ({
  data,
  state,
  trackingLineData,
  showFullTrackingButton,
  activateReturnShippingInfo,
  cancelActivateReturn,
  onOpenFullTrackingDrawer,
}) => {
  const isMobile = useIsMobile()
  const { determineShippingActionsMobile } = useShippingActions()

  const rowActions = Object.entries(
    determineShippingActionsMobile(data.info),
  ).filter(action => action[1].isActive)
  return (
    <>
      {isMobile ? (
        <>
          <BasicInfoSection data={data} state={state} />
          <OriginDestinationSection
            data={{
              shipmentInfo: data.info,
              state:state,
              shipmentStatus: data.info.shippingStatusCode.severity,
              from: data.from,
              to: data.to,
            }}
          />
          {rowActions.map(([actionType, actionConfig]) => (
            <Button
              size={'small'}
              style={styles.actionsButtons}
              key={actionType}
              onClick={actionConfig.onClick}
            >
              {actionConfig.label}
            </Button>
          ))}
        </>
      ) : (
        <TrackingSectionDesktop
          data={data}
          cancelActivateReturn={cancelActivateReturn}
          activateReturnShippingInfo={activateReturnShippingInfo}
          trackingLineData={trackingLineData}
          showFullTrackingButton={showFullTrackingButton}
          onOpenFullTrackingDrawer={onOpenFullTrackingDrawer}
        />
      )}
    </>
  )
}

Content.propTypes = {
  data: PropTypes.object,
  state: PropTypes.object,
  activateReturnShippingInfo: PropTypes.object,
  cancelActivateReturn: PropTypes.func,
  trackingLineData: PropTypes.object,
  showFullTrackingButton: PropTypes.bool,
  onOpenFullTrackingDrawer: PropTypes.func,
}

export default Content
